import {useApiEndpoint} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornDatasource} from "../../../../../application/business/StubbornAsset";

export const useEditionDatasourceApi = () => useApiEndpoint<StubbornDatasource>(PATH);
